import type { ReactElement } from 'react';

import CustomMetatag from '@/components/layouts/custom-metatag';
import Layout from '@/components/layouts/lcv';
import Brochure, {
  SectionDownloadBrochureProps,
} from '@/components/sections/download-brochure';
import {
  MU_X_MENU,
  PICKUP_4DOOR_MENU,
  SPARK_MENU,
  VCROSS_MENU,
} from '@/contents/lcv/lineup';
import {
  MENU_LCV_MODEL_D_MAX_LABEL,
  MENU_LCV_MODEL_MU_X_LABEL,
  MENU_LCV_MODEL_PICKUP_LABEL,
  MENU_LCV_MODEL_SUV_LABEL,
} from '@/contents/lcv/link';

export async function getStaticProps() {
  return {
    props: {},
  };
}

const Page = () => {
  const title = 'ດາວໂຫຼດໂບຊົວ - Isuzu TIS Laos';
  const description = 'ດາວໂຫຼດໂບຊົວລາຍລະອຽດລົດອີຊູຊຸທຸກລຸ້ນ';

  const brochureData: SectionDownloadBrochureProps = {
    title: 'ດາວໂຫຼດໂບຊົວ',
    description: 'ລາຍລະອຽດລົດອີຊູຊຸທຸກລຸ້ນ',
    submenu: [
      {
        url: '',
        label: MENU_LCV_MODEL_PICKUP_LABEL,
        submenu: [
          {
            url: '',
            label: MENU_LCV_MODEL_D_MAX_LABEL,
            submenu: [VCROSS_MENU],
          },
          {
            url: '',
            label: MENU_LCV_MODEL_D_MAX_LABEL,
            submenu: [PICKUP_4DOOR_MENU],
          },
          {
            url: '',
            label: MENU_LCV_MODEL_D_MAX_LABEL,
            submenu: [SPARK_MENU],
          },
        ],
      },
      {
        url: '',
        label: MENU_LCV_MODEL_SUV_LABEL,
        submenu: [
          {
            url: '',
            label: MENU_LCV_MODEL_MU_X_LABEL,
            submenu: [MU_X_MENU],
          },
        ],
      },
    ],
  };

  return (
    <>
      <CustomMetatag title={title} description={description} />
      <Brochure {...brochureData} />
    </>
  );
};

export default Page;

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};
